import classNames from 'classnames';
import { Banner } from '@fff-web/cms';
import * as styles from './HeroBanner.module.scss';

export const HERO_BANNER_CONTAINER = 'HERO_BANNER_CONTAINER';

const HeroBanner = () => {
  const classes = classNames(styles.wrapperBanner);
  return (
    <div className={classes} data-testid={HERO_BANNER_CONTAINER}>
      <Banner name="upgrade-to-annual-customize" themeColor="dark" />
    </div>
  );
};

export default HeroBanner;
